import type { Notice } from "@/pages/home/types";

interface NoticeModalProps {
  notice: Notice | null;
  onClose: () => void;
  onCopy: (text: string) => void;
}

export default function NoticeModal({ notice, onClose, onCopy }: NoticeModalProps) {
  if (!notice) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭"
        onClick={onClose}
        className="absolute inset-0 h-full w-full cursor-pointer bg-foreground-950/60"
      ></button>
      <div className="relative z-10 w-full max-w-md animate-fade-up overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-start justify-between gap-4 border-b border-background-200 bg-background-100 px-5 py-4">
          <div className="flex items-start gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-information-2-fill text-lg"></i>
            </span>
            <h3 className="pt-1 text-base font-bold leading-snug text-foreground-950">{notice.title}</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭弹窗"
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-200 hover:text-foreground-950"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="space-y-3 px-5 py-5">
          {notice.lines.map((line) => (
            <p key={line} className="text-sm leading-relaxed text-foreground-700">
              {line}
            </p>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-background-200 bg-background-100 px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200"
          >
            我知道了
          </button>
          {notice.copyText ? (
            <button
              type="button"
              onClick={() => onCopy(notice.copyText as string)}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-file-copy-line text-base"></i>
              {notice.copyLabel ?? "复制"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}